package com.findyourbuddies.website.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import kotlin.time.Duration.Companion.milliseconds

data class CarouselItemData(
    val imageUrl: String,
    val description: String
)

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun Carousel(
    modifier: Modifier = Modifier,
) {
    var isLandscape by remember { mutableStateOf(kotlinx.browser.window.innerWidth > 768) }

    LaunchedEffect(Unit) {
        val updateLayout = {
            isLandscape = kotlinx.browser.window.innerWidth > 768
        }

        kotlinx.browser.window.addEventListener("resize", {
            updateLayout()
        })
    }

    val carouselItems = listOf(
        CarouselItemData(
            imageUrl = "/images/mockups/mockup_01.png",
            description = "Find freedivers around you using geolocation."
        ),
        CarouselItemData(
            imageUrl = "/images/mockups/mockup_02.png",
            description = "Check out their profile for information about their level, equipment, and more!"
        ),
        CarouselItemData(
            imageUrl = "/images/mockups/mockup_03.png",
            description = "Get in touch with them using the chat built into the app!"
        )
    )

    val coroutineScope = rememberCoroutineScope()

    var currentIndex by remember { mutableStateOf(0) }
    var isAutoPlay by remember { mutableStateOf(true) }

    LaunchedEffect(currentIndex, isAutoPlay) {
        if (isAutoPlay) {
            delay(5000.milliseconds) // 5 secondes
            currentIndex = (currentIndex + 1) % carouselItems.size
        }
    }

    Column(
        modifier = modifier
            .fillMaxWidth()
            .padding(8.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(if (isLandscape) 600.px else 450.px) // Hauteur encore plus réduite pour portrait
                .overflow(Overflow.Hidden)
                .position(Position.Relative)
        ) {
            carouselItems.forEachIndexed { index, item ->
                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(0.px)
                        .left((index - currentIndex) * 150.percent)
                        .width(100.percent)
                        .height(100.percent)
                        .styleModifier {
                            property("transition", "left 0.5s ease-in-out")
                        },
                    contentAlignment = Alignment.Center
                ) {
                    CarouselItem(
                        imageUrl = item.imageUrl,
                        description = item.description,
                        isLandscape = isLandscape,
                    )
                }
            }
        }

        Row(
            modifier = Modifier.margin(top = 20.px),
            horizontalArrangement = Arrangement.Center
        ) {
            carouselItems.forEachIndexed { index, _ ->
                CarouselDot(
                    isActive = index == currentIndex,
                    onClick = {
                        currentIndex = index
                        isAutoPlay = false

                        coroutineScope.launch {
                            delay(10000.milliseconds)
                            isAutoPlay = true
                        }
                    }
                )
            }
        }
    }
}

@Composable
fun CarouselDot(
    isActive: Boolean,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .size(12.px)
            .margin(right = 6.px, left = 6.px)
            .borderRadius(50.percent)
            .backgroundColor(if (isActive) rgb(98, 131, 178) else rgba(98, 131, 178, 0.3))
            .cursor(Cursor.Pointer)
            .styleModifier {
                property("transition", "background-color 0.3s ease")
            }
            .attrsModifier {
                onClick { onClick() }
            }
    )
}

